import picsioConfig from '../../../../../../config';

const isArchiveAllowed = (user) => {
  if (!picsioConfig.isMainApp) return false;
  return user ? user.role.permissions.viewArchive : false;
};

export default isArchiveAllowed;
